import { useIsOwner, useSessionPermission, usePermissionsChecker } from '@btime/react-session'
import React from 'react'

import Center from '../../../components/helpers/Center'
import IconBlock from '../../../components/presentation/IconBlock'

const PermissionChecker = ({ ownerOnly, permission, any, all, hideMessage, title, message, children }) => {
  const checkPermission = usePermissionsChecker()
  const considerAll = !!all?.length
  const names = permission ? [permission] : all || any
  const hasPermission = checkPermission(names, considerAll) || !names?.length

  const hasOwnerPermission = !!useIsOwner() || !ownerOnly

  if (!hasPermission || !hasOwnerPermission) {
    if (!!hideMessage) return false
    return (
      <Center>
        <IconBlock
          icon="BsShieldLock"
          title={title || 'Você não têm permissão para ver essa página!'}
          subtitle={message || 'Verifique com o admin do sistema se precisar ter mais acesso'}
        />
      </Center>
    )
  }

  return children
}

export default PermissionChecker
